import { render, staticRenderFns } from "./LessonRegister.vue?vue&type=template&id=8e55145c"
import script from "./LessonRegister.vue?vue&type=script&lang=js"
export * from "./LessonRegister.vue?vue&type=script&lang=js"
import style0 from "./LessonRegister.vue?vue&type=style&index=0&id=8e55145c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports